<!--
 * @Description: 取证组件
 * @Author: dengnanhao
 * @Date: 2021-05-15 13:48:50
 * @LastEditors: dengnanhao
 * @LastEditTime: 2021-08-04 09:56:30
-->
<template>
  <iframe
    ref="ForensicComponent"
    :src="url"
    frameborder="0"
    :style="`height: ${clientHeight - 124}px;`"
    scrolling="yes"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex';
const URL_PREFIX = '/forensic-component/#'
// const URL_PREFIX = 'http://192.168.1.184:9527/#'

export default {
  name: 'ForensicComponent',
  data() {
    const { id } = this.$route.query
    return {
      url: `${URL_PREFIX}/forensic${id ? '/report/' + id : '/upload'}`
    }
  },
  computed: {
    ...mapState({
      itemPromise: state => state.forensic.item,
      clientHeight: state => state.global.client.height,
      forensicAgain: state => state.forensic.forensicAgain,
      forensicFileType: state => state.forensic.forensicFileType
    })
  },
  mounted() {
    const iframe = this.$refs.ForensicComponent
    this.itemPromise().then(data => {
      iframe.onload = () => {
        iframe.contentWindow.postMessage({
          platform: 't3',
          token: this.token,
          includeForensicList: 2, // 是否集成取证列表，1代表集成，2代表不集成
          forensicRecord: data,
          forensicAgain: this.forensicAgain, // 是否重新取证：0新建取证，1重新取证
          uploadType: this.forensicFileType // 取证文件的类型：img/video/pdf
        }, '*')
      }
    })

    // TODO子传父type定义
    // 1、1代表token失效，退出登录
    // 2、101代表返回取证列表页
    window.addEventListener('message', (even) => {
      const data = even.data
      if (data.type && data.type == 1) {
        this.logout()
      }
      // 返回列表页
      if (data.type && data.type == 101) {
        this.linkTo('/selfForensic/list')
      }
    })
  },
  methods: {
    ...mapActions({
      logout: 'admin/logout'
    })
  }
}
</script>

<style lang="scss">
    iframe {
        width: 100%;
        height: 100%;
    }
</style>
